<cmps-wait-status
    [srStatus]="'Loading ' + config.title"
    *ngIf="hasPendingData"
></cmps-wait-status>
<div *ngIf="!hasPendingData && data == null">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<ng-container *ngIf="!hasPendingData && data != null">
    <div class="progress cmps-widget-management-effectiveness-progress">
        <div
            class="progress-bar"
            aria-describedby="managementEffectivenessScore"
            aria-valuemin="0"
            aria-valuemax="100"
            [attr.aria-valuenow]="data.progress.score * 100"
            [ngStyle]="{
                'width.%': data.progress.score * 100,
                'background-color': data.progress.color
            }"
        ></div>
        <div
            class="progress-text"
            [ngStyle]="{ 'width.%': data.progress.score * 100 }"
        >
            {{ data.progress.score | percent: '1.0-0' }}
        </div>
        <span
            class="sr-only"
            id="managementEffectivenessScore"
            >{{ data.progress.score | percent: '1.0-0' }}</span
        >
    </div>
    <div class="table-responsive">
        <table class="table table-striped table-sm table-bordered-no-cells">
            <thead class="thead-light">
                <tr>
                    <th>{{ i18n._713_METRIC | translate }}</th>
                    <th>{{ i18n._752_SCORE | translate }}</th>
                    <th>{{ i18n._726_TARGET | translate }}</th>
                    <th>{{ i18n._746_DETAILS | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let i of data.items; let ii = index">
                    <td>{{ i.metricName }}</td>
                    <td>
                        {{
                            i.score == null ? '-' : (i.score | percent: '1.0-0')
                        }}
                    </td>
                    <td>
                        {{
                            i.target == null
                                ? '-'
                                : (i.target | percent: '1.0-0')
                        }}
                    </td>
                    <!--TODO revise-->
                    <td
                        class="text-center"
                        [ngSwitch]="ii"
                    >
                        <button
                            type="button"
                            class="cmps-btn-table"
                            (click)="showDetails()"
                            *ngSwitchCase="1"
                        >
                            <cmps-icon svgIcon="list-box-outline"></cmps-icon>
                        </button>
                        <button
                            type="button"
                            class="cmps-btn-table"
                            (click)="showMi2Details()"
                            *ngSwitchCase="3"
                        >
                            <cmps-icon svgIcon="list-box-outline"></cmps-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-container>
